import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pression',
  standalone: true
})
export class PressionPipe implements PipeTransform {

  transform(value: number | string | undefined, ...args: unknown[]): string | undefined {
    return typeof value == 'number' ? `${new DecimalPipe('fr').transform(value, '1.2-2')}cmH2O` : value;
  }

}
